import React from 'react';
import MatchTable from '../Common/MatchTable';
import { Remark } from '../Common/MatchBase';

const TEAMFCH = () => {
    return (
        <section className='TEAMFCH'>
            <MatchTable betType='TEAMFCH'/>
            <Remark />
        </section>
    )
}
export default TEAMFCH;